/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Delete_Records_TitleInputs */

const en_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Records`)
};

const fr_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer des enregistrements`)
};

const de_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datensätze löschen`)
};

const it_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina record`)
};

const ru_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить записи`)
};

const es_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar registros`)
};

const zh_cn2_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除记录`)
};

const ja_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードを削除`)
};

const hi_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड हटाएं`)
};

const pt_pt2_explorer_display_delete_records_title = /** @type {(inputs: Explorer_Display_Delete_Records_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir registros`)
};

/**
* | output |
* | --- |
* | "Delete Records" |
*
* @param {Explorer_Display_Delete_Records_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_records_title = /** @type {((inputs?: Explorer_Display_Delete_Records_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Records_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_delete_records_title(inputs)
	if (locale === "de") return de_explorer_display_delete_records_title(inputs)
	if (locale === "it") return it_explorer_display_delete_records_title(inputs)
	if (locale === "ru") return ru_explorer_display_delete_records_title(inputs)
	if (locale === "es") return es_explorer_display_delete_records_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_delete_records_title(inputs)
	if (locale === "ja") return ja_explorer_display_delete_records_title(inputs)
	if (locale === "hi") return hi_explorer_display_delete_records_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_delete_records_title(inputs)
	return en_explorer_display_delete_records_title(inputs)
});